import React from 'react';
import { countryCodeToFlag, countryCodeToName } from 'utils/countryDisplay';

/**
 * Inline country flag indicator.
 *
 * @param {string|null} countryCode - 2-letter ISO country code
 */
export const GeoIndicator = ({ countryCode }) => (
    <span role="img" aria-label={countryCodeToName(countryCode)} title={countryCodeToName(countryCode)}>
        {countryCodeToFlag(countryCode)}
    </span>
);
